import {CheckoutNavigationService, DowngradeModalModule, ShopVariationService} from '@webu/ui';
import {CommonModule} from '@angular/common';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AlertModule, GeneralModalModule, LoadingModule} from '@ox/ui';
import {LinkPipeModule, SharedUtilsModule} from '@ox/utils';
import {PlanDetailPageComponent} from './ui/plan-detail-page/plan-detail-page.component';
import {VehicleSwitcherModule, SharedNavModule, SharedNavWrapperModule, LocationService} from '@webu/ui';
import {TranslateModule} from '@ox/translate';
import {EcppDataService, ShopServiceModule} from '@webu/data';
import {PdpService, PageNameService, CheckoutService, CheckoutDataService, OfferService} from './services';

export const ROUTES = [
  {
    path: '',
    component: PlanDetailPageComponent,
    outlet: 'pdp',
    children: []
  }
];

@NgModule({declarations: [
        PlanDetailPageComponent
    ],
    exports: [PlanDetailPageComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        SharedUtilsModule,
        GeneralModalModule,
        LoadingModule,
        VehicleSwitcherModule,
        SharedNavModule,
        SharedNavWrapperModule,
        TranslateModule,
        ShopServiceModule,
        RouterModule.forChild(ROUTES),
        LinkPipeModule,
        AlertModule,
        DowngradeModalModule], providers: [
        CheckoutDataService,
        CheckoutService,
        OfferService,
        PdpService,
        PageNameService,
        LocationService,
        CheckoutNavigationService,
        ShopVariationService,
        EcppDataService,
        provideHttpClient(withInterceptorsFromDi())
    ]})
export class PdpMainModule {
}
